/**
 * Zone.js configuration flags
 * CRITICAL: Must be set BEFORE any imports
 */

// Prevents Angular change detection from running with certain Web Component callbacks
// Important for Ionic components performance
(window as any).__Zone_disable_customElements = true;

// Performance optimizations
(window as any).__Zone_disable_requestAnimationFrame = true;
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove'];

/**
 * Now import Zone.js and Angular modules
 */
import 'zone.js'; // Required for Angular

import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import localeEs from '@angular/common/locales/es';
import { enableProdMode, inject, isDevMode, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, RouteReuseStrategy, withNavigationErrorHandler } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { Capacitor } from '@capacitor/core';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideSessionBootstrap } from '@okcargo-apps/shared-application-ionic';
import { StorageRepository } from '@okcargo-apps/shared-domain';
import {
  apiInterceptor,
  APP_CONFIG,
  ConnectivityService,
  OfflineNavigationRecoveryService,
  offlineInterceptor,
  provideConnectivityBootstrap,
} from '@okcargo-apps/shared-infrastructure';
import { CapacitorConnectivityService, CapacitorStorageService } from '@okcargo-apps/shared-infrastructure-ionic';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { environment } from './environments/environment';

registerLocaleData(localeEs);

defineCustomElements(window);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    {
      provide: APP_CONFIG,
      useValue: {
        ...environment,
        // firebase: firebaseConfig,
      },
    },
    { provide: StorageRepository, useClass: CapacitorStorageService },
    { provide: ConnectivityService, useClass: CapacitorConnectivityService },
    // The connectivity status must be known before the app makes any request.
    provideConnectivityBootstrap(),
    // The stored session (tokens and account snapshot) is applied before the guards run.
    provideSessionBootstrap(),
    provideZoneChangeDetection(),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({
      innerHTMLTemplatesEnabled: true,
    }),
    provideHttpClient(withXhr(), withInterceptors([offlineInterceptor, apiInterceptor])),
    provideRouter(
      routes,
      // A lazy chunk that failed while offline stays broken until the document is reloaded.
      withNavigationErrorHandler((error) => inject(OfflineNavigationRecoveryService).handleNavigationError(error)),
    ),
    { provide: LOCALE_ID, useValue: 'es-ES' },
    provideServiceWorker('ngsw-worker.js', {
      enabled: (!isDevMode() || environment.production) && !Capacitor.isNativePlatform(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    provideTranslateService({
      fallbackLang: 'en',
    }),
    provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json',
    }),
  ],
});
